import axios from 'axios'

export const _dev = process.env.NODE_ENV === 'development'

let BASE_URL = _dev
  ? 'http://localhost:44331'
  : process.env.REACT_APP_ENVIROMENT === 'testing' ? 'https://qa.yaguaneonline.com.ar/apionline' : 'https://qa.yaguaneonline.com.ar/apionline' // URL backend para deploy'

// let BASE_URL = 'http://localhost:44331'
//'https://alvearonline.com.ar:9993'
// TEST 'http://192.168.11.10:7773'


const _axios = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  withCredentials: true
})

// agrego un interceptor a las respuestas del cliente api...
_axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  // si se produjo un error de permisos, redirijo al login
  // si el ruteo actual es producto, no redirecciono para permitir acceso anonimo
  if (error.response && error.response.status === 401) {
    if (!window.location.hash.includes('/producto/')) {
        window.location.hash = '/Login'
        return false
    }
  }

  return Promise.reject(error)
});

_axios.get('/api/instalacion/GetTitlePage', {
  params: {
    title: 'Title'
  }
})
  .then(response => {
    const data = response.data;

    if ('title' in data) {
      document.title = data.title;
    } else {
      console.error('La propiedad "title" no está presente en la respuesta de la API.');
    }
  })
  .catch(error => {
    console.error('Error al obtener el título:', error);
  });

export default _axios